import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.reportExportDetail

export const queryKeys = {
  templates: [...prefix, 'templates'] as const,
  loginPlaces: [...prefix, 'loginPlaces'] as const,
  userBelongingPlaces: [...prefix, 'userBelongingPlaces'] as const,
}
